<template>
  <div class="service-utilize-container">
    <div class="columns is-multiline">
      <div class="column is-full">
        <admin-filter
          :items="filterData"
          :itemFiltered.sync="filtered"
          @getData="getDataFromServer"
          title="이용내역 조회"
          ref="admin_filter"></admin-filter>
      </div>
      <div class="column is-full">
        <admin-table :field_list="tableData"
                     :items="tableItems"
                     :filtered="filtered"
                     :allCount="allCount"
                     :filteredCount="filteredCount"
                     :table_width="1808"
                     @getData="getDataFromServer"
                     @ordering="ordering"
                     @selPageLength="selPageLength">
          <div slot="billing_date" slot-scope="props">{{ datesFormat(props.item.billing_date, 'date_3') }}</div>
          <div slot="product_price" slot-scope="props">{{ currency(props.item.product_price) }}</div>
          <div slot="account_price" slot-scope="props">{{ currency(props.item.account_price) }}</div>
          <div slot="product_name" slot-scope="props">
            {{ props.item.product_content ? props.item.product_content : props.item.product_name }}
            <span v-if="props.item.membership_name">{{ props.item.membership_name }}</span></div>
          <div slot="pay_method" slot-scope="props">{{ pay_method_kor(props.item.pay_method) }}</div>
          <div slot="status" slot-scope="props">{{ status_kor(props.item.status) }}</div>
          <div slot="account_date" slot-scope="props">{{ datesFormat(props.item.account_date, 'date_3') }}</div>
        </admin-table>
      </div>
    </div>
  </div>
</template>

<script>
  import Pagination from "../../module/common/Pagination";
  import LpAdmDropInput from "../../module/common/LpAdmDropInput";
  import ListMixin from "../../../mixins/ListMixin";

  export default {
    name: 'MyPaymentList',
    mixins: [
      ListMixin
    ],
    components: {
      LpAdmDropInput,
      Pagination
    },
    created() {
      this.init();
    },
    data() {
      return {
        filter: {
          start_date: '',
          end_date: '',
          pay_method: [],
          category: 0,
          status: -1
        },
        page: {
          cur_page: 1,
          page_length: 10,
          total_page: 2
        },
        option: {
          pay_method: [
            {value: 0, label: '빌링결제(이니시스)', checked: false},
            {value: 1, label: '계좌이체', checked: false},
            {value: 2, label: '빌링결제(페이플)', checked: false},
            {value: 3, label: '충전금 소진', checked: false}
          ],
          category: [],
          status: [
            {value: '', label: '전체'},
            {value: 0, label: '결제대기'},
            {value: 1, label: '결제완료'},
            {value: 2, label: '입금완료'}
          ]
        },
      }
    },
    methods: {
      pay_method_kor(item) {
        return this.option.pay_method.filter(i => i.value === item)[0].label;
      },
      status_kor(item) {
        return this.option.status.filter(i => i.value === item)[0].label;
      },
      getDataFromServer() {
        this.getData();
      },
      getMasterUrl(path) {
        return `${this.masterBackendUrl}serviceadmin/${this.$store.getters.admin.id}/launchpack/service/${this.$store.getters.masterService.service_id}/${path}`;
      },
      async init() {
        this.initializing('service_utilize', this.getMasterUrl('utilize'));
        this.filtered.ordering = '-billing_date';

        let res = await this.$axios.get(`${this.masterBackendUrl}public/category?depth=3`);
        let categories = [{
          id: '',
          name: '전체'
        }];
        // 디자인마켓
        categories.push(res.data.filter(i => i.id === 39)[0].child.filter(i => i.name === '테마')[0]);
        // 앱마켓
        categories = categories.concat(res.data.filter(i => i.id === 46)[0].child);
        // 서비스 관리
        categories.push(res.data.filter(i => i.name === 50)[0].child.filter(i => i.name === '호스팅')[0]);

        this.option.category = categories.map(i => {
            return {
              label: i.name,
              value: i.id
            }
          });

        this.$nextTick(()=>{
          let items = this.$refs.admin_filter.items;
          items.filter(i => i.key === 'pay_method')[0].options = this.option.pay_method;
          items.filter(i => i.key === 'status')[0].options = this.option.status;
          items.filter(i => i.key === 'category')[0].options = this.option.category;
        });
        this.getData();
      },
      filter_valid(item, key) {
        if (item[key] === '' || item[key] === 0 || item[key] === -1 ||
          (Array.isArray(item[key]) && item[key].length() === 0)) {
          delete item[key];
        }
      },
      getDatas() {
        let params = this.cloneItem(this.filter);
        params.pay_method = params.pay_method.toString();
        this.filter_valid(params, 'category');
        this.filter_valid(params, 'start_date');
        this.filter_valid(params, 'end_date');
        this.filter_valid(params, 'pay_method');
        if(params.status === -1) {
          this.filter_valid(params, 'status');
        }
        params.page_num = this.page.cur_page;
        params.page_length = this.page.page_length;

        this.$axios.get(this.getMasterUrl('utilize'), {params: params}).then(res=>{
          this.tableItems = res.data.data.map(item => {
            item.pay_method_kor = this.option.pay_method.filter(i => i.value === item.pay_method)[0].label;
            item.status_kor = this.option.status.filter(i => i.value === item.status)[0].label;
            return item;
          });
          this.page.total_page = res.data.total_page;
        });
      },
    }
  }
</script>

<style lang="stylus" scoped>
  $background2=#f5f5f5
  $border-main=#dddddd
  $border-sub=#eeeeee
  $primary=#ff5722

  .grid-row
  .grid-row-end
    display grid
    grid-column-gap 8px
    font-size 14px
    margin-bottom 8px
    align-items center

  .grid-row
    grid-template-columns 120px 1fr

  .grid-row-end
    grid-template-columns 1fr 90px
    text-align right

  .grid-title
    font-weight 600

  .button
    width 110px

  .check-box
    input
      margin-right 4px
      vertical-align middle
      border 1px solid #dddddd

  .service-utilize-container
    table
      width 100%
      border 1px solid $border-main
      th
      td
        vertical-align middle
        text-align center
        border 1px solid $border-main
        padding 4px 8px
      th
        background-color $background2
      tr:hover
        background-color #ff572210
        cursor pointer
</style>
<style lang="stylus">
  .lp-date-picker
    margin-bottom 0 !important
  .mx-datepicker
    width 130px
  .title-group
    margin-bottom 12px !important
</style>
